<template>
  <a-layout class="process-parameters-body" style="height: 100%">
      <a-layout-sider width="360" style="background: #fff; min-width:360px; overflow:auto;" class="no-fix-sider">
          <a-tree
              blockNode
              :defaultSelectedKeys="selectedKeys"
              :selectedKeys="selectedKeys"
              :expandedKeys="expendKeys"
              :tree-data="treeData"
              @expand="expandKey"
              @select="onSelect"
            >

            <template slot="custom" slot-scope="item">
              {{item.title}}

              <template v-if="item.expanded">
                <a-icon v-if="item.children" type="folder-open" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -21px; top: 2px; z-index: 10;'/>


              </template>

              <template v-if="!item.expanded">
                <a-icon v-if="item.children" type="folder" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -21px; top: 2px; z-index: 10;'/>
              </template>

            </template>

          </a-tree>
      </a-layout-sider>
      <div v-resize="'x'"></div>
      <a-layout-content>
        <div class="button-wapper">
          <a-button style="margin-left: 8px;"  @click="syncVisible=true">{{ $t('page_andon_call_synchronization_settings') }}</a-button>
        </div>
        <ml-table :columns="columns" :data-source="data" :scroll="{x:1700, y: scrallHeight}" :loading="loading">
          <template slot="action" slot-scope="text, record">
            <div class="editable-row-operations">
              <span v-if="record.editable">
                <a v-acl="'page_mdc_setting_condition_save'" @click="() => save(record)"><a-icon type="check" /></a>
                <a-divider type="vertical"/>
                <a v-acl="'page_mdc_setting_condition_cancel'" @click="cancel(record)" style="color: #ff0000"><a-icon type="close" /></a>
              </span>
              <span v-else>
                <a v-acl="'page_mdc_setting_condition_edit'" :disabled="editingKey !== '' || text == '0'" @click="() => edit(record.id)">{{$t('edit')}}</a>
                <a-divider type="vertical"/>
                <a-popconfirm :disabled="editingKey !== '' || text == '0'" :title="$t('page_mdc_setting_sure_delete')" @confirm="() => handleDelete(record)">
                  <a v-acl="'page_mdc_setting_condition_delete'" :disabled="editingKey !== '' || text == '0'" :style="{color: (editingKey !== '' || text == '0') ? '#00000040' : '#ff0000'}">{{$t('delete')}}</a>
                </a-popconfirm>
              </span>
            </div>
          </template>
          <template slot="productTypeName" slot-scope="text, record">
              <span v-if="record.editable">
                <a-select :show-search="true"
                optionFilterProp="children"
                v-model="record.productTypeId" @change="changeProductType($event, record)" style="width:200px">
                    <a-select-option v-for="(type,index) in productTypeList" :key="index" :value="type.id">{{type.name}}</a-select-option>
                </a-select>
              </span>
              <span v-else>
                {{record.productTypeName}}
              </span>
          </template>
          <template slot="productInfo" slot-scope="text, record">
              <span v-if="record.editable">
                <a-select :show-search="true" optionFilterProp="children" v-model="record.productInfo" style="width:200px" @change="changeProductInfo($event, record)">
                    <a-select-option v-for="(info,index) in productInfoList" :key="index" :value="info.info">{{info.info}}</a-select-option>
                </a-select>
              </span>
              <span v-else>
                {{record.productInfo}}
              </span>
          </template>
          <template slot="productCode" slot-scope="text, record">
              <span v-if="record.editable && !record.productInfo">
                <a-input v-model="record.productCode"></a-input>
              </span>
              <span v-else>
                {{record.productCode}}
              </span>
          </template>
          <template slot="productName" slot-scope="text, record">
              <span v-if="record.editable && !record.productInfo">
                <a-input v-model="record.productName"></a-input>
              </span>
              <span v-else>
                {{record.productName}}
              </span>
          </template>
          <template slot="programName" slot-scope="text, record">
              <span v-if="record.editable">
                <a-input v-model="record.programName"></a-input>
              </span>
              <span v-else>
                {{record.programName}}
              </span>
          </template>
          <template slot="standardCapacityDay" slot-scope="text, record">
              <span v-if="record.editable">
                <a-input-number v-model="record.standardCapacityDay" :min="0"></a-input-number>
              </span>
              <span v-else>
                {{record.standardCapacityDay}}
              </span>
          </template>
          <template slot="standardCapacityWeek" slot-scope="text, record">
              <span v-if="record.editable">
                <a-input-number v-model="record.standardCapacityWeek" :min="0"></a-input-number>
              </span>
              <span v-else>
                {{record.standardCapacityWeek}}
              </span>
          </template>
          <template slot="standardCapacityMonth" slot-scope="text, record">
              <span v-if="record.editable">
                <a-input-number v-model="record.standardCapacityMonth" :min="0"></a-input-number>
              </span>
              <span v-else>
                {{record.standardCapacityMonth}}
              </span>
          </template>
          <template slot="shiftCapacity" slot-scope="text, record">
              <span v-if="record.editable">
                <a-input-number v-model="record.shiftCapacity" :min="0"></a-input-number>
              </span>
              <span v-else>
                {{record.shiftCapacity}}
              </span>
          </template>
          <template slot="colour" slot-scope="text, record">
              <span v-if="record.editable">
                <!-- <chrome-picker v-model="record.colour" slot="overlay"></chrome-picker> -->
                <colorPicker v-model="record.colour"/>
              </span>
              <span v-else :style="{'background-color': record.colour}" class="bg-color">
              </span>
          </template>
          <template
            slot="standardTime"
            slot-scope="text, record"
          >
          <div>
            <div  v-if="record.editable"  style="min-width: 250px">
              <div style="width:250px">
                <a-input-number v-model="record.standardTimeObj.day" @change="changeStandardTime($event, 'day', record)" :min="0" class="input-number"></a-input-number>
                <a-input-number v-model="record.standardTimeObj.hour" :min="0" class="input-number"></a-input-number>
                <a-input-number v-model="record.standardTimeObj.minute" :min="0" class="input-number"></a-input-number>
                <a-input-number v-model="record.standardTimeObj.second" :min="0" class="input-number"></a-input-number>
                <a-button @click="countTime" type="primary" style="margin-left:10px">{{ $t('page_andon_call_calculation') }}</a-button>
              </div>
            </div>
            <template v-else>{{ convertSeconds(text) }}</template>
          </div>
      </template>
        </ml-table>
        <a-button :disabled="editingKey !== ''" type="primary" style="width: 100%;margin: 8px 0" @click="handleAdd()"><a-icon type="plus" />{{ $t('page_andon_call_create_setting') }}</a-button>
      </a-layout-content>
      <sync-equipment-standard-setting @close="syncVisible=false" :treeData="treeData" :visible="syncVisible" :workStationId="workStationId" :allTree='allTree'></sync-equipment-standard-setting>
      <equipmentCount :visible="countVisible" @countFinish="countFinish" @countClose="countClose">
      </equipmentCount>
    </a-layout>
</template>
<script>
import { DeviceStandardSettingServiceProxy, WorkStationGroupServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { DataTreeNode } from '@/utils/array'
import Vue from 'vue'
import { convertSeconds } from '@/utils/index'
import syncEquipmentStandardSetting  from './syncEquipmentStandardSetting.vue'
import { ProductTypeServiceProxy, ProductServiceProxy } from '@/service-proxies/app-v2/product.service-proxies'
import { cloneDeep } from "lodash";
import equipmentCount from './equipmentCount.vue'
const deviceStandardSettingServiceProxy = new DeviceStandardSettingServiceProxy()
const productTypeServiceProxy = new ProductTypeServiceProxy()
const wsgsp = new WorkStationGroupServiceProxy();
const productServiceProxy = new ProductServiceProxy()

const ONE_DAY = 60 * 60 * 24;
const ONE_HOUR = 60 * 60;
const ONE_MINUTE = 60;
export default  Vue.extend({
  components: {
    "sync-equipment-standard-setting": syncEquipmentStandardSetting,
    equipmentCount
  },
  data() {
    return {
      data: [],
      editingKey: '',
      scrallHeight: 750,
      loading: false,
      selectedKeys: [],
      expendKeys: [],
      treeData: [],
      workStatoinItems: [],
      productTypeList: [],
      productInfoList: [],
      count: 0,
      cacheData: [],
      syncVisible: false,
      workStationId: '',
      countVisible: false,
      allTree: []
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('actions'),
          dataIndex: 'action',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'action' }
        },
        {
          title: this.$t('page_product_type'),
          dataIndex: 'productTypeName',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'productTypeName' },
        },
        {
          title: this.$t('page_quality_product_information'),
          dataIndex: 'productInfo',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'productInfo' },
        },
        {
          title: this.$t('page_plan_product_no'),
          dataIndex: 'productCode',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'productCode' },
        },
        {
          title: this.$t('page_plan_product_name'),
          dataIndex: 'productName',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'productName' },
        },
        {
          title: this.$t('page_plan_procedure_number'),
          dataIndex: 'programName',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'programName' },
        },
        {
          title: this.$t('page_product_standard_time'),
          dataIndex: 'standardTime',
          width: 300,
          ellipsis: true,
          scopedSlots: { customRender: 'standardTime' },
        },
        {
          title: this.$t('page_station_shift_capacity'),
          dataIndex: 'shiftCapacity',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'shiftCapacity' },
        },
        {
          title: this.$t('page_station_standard_capacity_daily'),
          dataIndex: 'standardCapacityDay',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'standardCapacityDay' },
        },
        {
          title: this.$t('page_station_standard_capacity_week'),
          dataIndex: 'standardCapacityWeek',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'standardCapacityWeek' },
        },
        {
          title: this.$t('page_station_standard_capacity_month'),
          dataIndex: 'standardCapacityMonth',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'standardCapacityMonth' },
        },
        {
          title: this.$t('page_equipment_standard_color_settings'),
          dataIndex: 'colour',
          width: 210,
          ellipsis: true,
          scopedSlots: { customRender: 'colour' },
        },
      ]
    }
  },
  created() {
    const scrall = document.querySelector('#app')
    this.scrallHeight = scrall.clientHeight - 175
    this.getTreeList()
    this.getProductTypeList()
  },
  methods: {
    covertStardTimeToSecond(standardTime = {day: 0, hour: 0, minute: 0, second: 0}) {
      return standardTime.day * ONE_DAY + standardTime.hour * ONE_HOUR + standardTime.minute * ONE_MINUTE + standardTime.second;
    },
    // 把标准工时的秒 解析成天时分秒
    // type 为day hour minute second
    covertStardTime(num) {
      return {
        day: Math.trunc(num / ONE_DAY),
        hour: Math.trunc(num % ONE_DAY / ONE_HOUR),
        minute: Math.trunc(num % ONE_DAY % ONE_HOUR / ONE_MINUTE),
        second: Math.trunc(num % ONE_DAY % ONE_HOUR % ONE_MINUTE)
      }
    },
    convertSeconds,
    changeProductInfo(code, record) {
      console.log('code', code)
      const info = this.productInfoList.find(res => res.info === code)
      if (info) {
        record.productCode = info.code
        record.productName = info.name
      }
    },
    edit(id) {
      const newData = [...this.data];
      const target = newData.filter(item => id === item.id)[0];
      this.$set(target, 'standardTimeObj', this.covertStardTime(target.standardTime))
      // target.standardTimeObj = this.covertStardTime(target.standardTime)
      this.editingKey = id;
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    getProductTypeList() {
      productTypeServiceProxy.getPageProductTypes(1, '', '', 999, 2).then(res => {
        this.productTypeList = res.records
        this.productTypeList.unshift({
          description: this.$t('page_workstation_empty'),
          id: this.$t('page_workstation_empty'),
          name: this.$t('page_workstation_empty')
        })
      })
    },
    covertStandardTime(time) {
      if (parseInt(time[time.length - 1]) >= 5) {
        time = parseInt(time) + (10 - parseInt(time[time.length - 1]))
      } else {
        time = parseInt(time) - parseInt(time[time.length - 1])
      }
      return time || 0
    },
    save(record) {
      const originRecord = cloneDeep(record)
      const productType = this.productTypeList.find(res => res.id === record.productTypeId) || {}
      const originStandardTime = this.covertStardTimeToSecond(record.standardTimeObj)
      record.standardTime =  originStandardTime
      if (record.standardTime === 0) {
        this.$message.error(this.$t('page_plan_work_procedure_tip3'))
        return
      }
      if (record.productTypeId === this.$t('page_workstation_empty')) {
        record.productTypeId = ''
      }
      record.productTypeName = productType.name
           // 初始的标准用时

      record.workStationId = this.workStationId
      if (record.colour.hex) {
        record.colour = record.colour.hex
      }
      if(record.id == undefined){
        deviceStandardSettingServiceProxy.insertDeviceStandardSetting([record]).then(res =>{
          this.getList()
        }).catch(() => {
          record = originRecord
        })
      } else {
        deviceStandardSettingServiceProxy.updateDeviceStandardSetting([record]).then(res =>{
          this.getList()
        }).catch(() => {
          record = originRecord

        })
      }
      this.editingKey = '';
    },
    getTreeList(){
      this.workStatoinItems = []
      this.expendKeys = []
      this.selectedKeys = []
      wsgsp.workStationGroupList().then(res =>{
        if(res){
          this.allTree = res;
          const data = res.reduce((total, value) =>{
            const key = value.id + '-' + value.parentId
            let selectable = false
            if(value.isWorkStation){
              selectable = true
            }
            total.push({
              ...value,
              key: key,
              selectable: selectable
              })
              if(value.isWorkStation && !this.selectedKeys.length){
                this.selectedKeys.push(key)
                this.workStationId = this.selectedKeys && this.selectedKeys[0] && this.selectedKeys[0].split('-')[0]
                this.getList()
              } else if(value.isGroup){
                this.expendKeys.push(key)
              }
            return total
          }, [])
          this.treeData = DataTreeNode.arrayToTree(data);

          let copy = this.treeData
          copy.forEach((x) => {
            x.scopedSlots = {
              title: 'custom'
            }
            x.name = x.title;
            if(x.children) {
              x.children.forEach((y) => {
                y.scopedSlots = {
                  title: 'custom'
                }
                y.name = y.title;
                if(y.children) {
                  y.children.forEach((z) => {
                    z.scopedSlots = {
                      title: 'custom'
                    }
                    z.name = z.title;
                    if(z.children) {
                      z.children.forEach((a) => {
                        a.scopedSlots = {
                          title: 'custom'
                        }
                        a.name = a.title;
                      })
                    }
                  })
                }
              })
            }
          })
          this.treeData = copy

          this.workStatoinItems = data
        }
      })
    },
    getList(){
      this.loading= true
      this.data = []
      const id = this.selectedKeys && this.selectedKeys[0] && this.selectedKeys[0].split('-')[0]
      deviceStandardSettingServiceProxy.getDeviceStandardSettingList(id).then(res =>{
        console.log('ress', res)
        this.loading = false
        this.data = res
        this.cacheData = cloneDeep(this.data)
      })
    },
    expandKey(value){
      this.expendKeys = value
    },
    onSelect(value){
      if (value.length === 0) {
        return
      }
      this.selectedKeys = value
      console.log('1111', this.selectedKeys)
      this.workStationId = this.selectedKeys && this.selectedKeys[0] && this.selectedKeys[0].split('-')[0]
      console.log('2222', this.workStationId)
      this.editingKey = ''
      this.getList()
    },
    changeProductType(typeId, record) {
      console.log(111, typeId, record)
      this.productInfoList = []
      record.productInfo = ''
      record.productName = ''
      record.productCode = ''
      productServiceProxy.getProductInfo(typeId).then(res => {
        this.productInfoList = res
      })
    },
    cancel(record) {
      const id = record.id
      if(id == undefined){
        const data = [...this.data];
        this.count -= 1
        this.data = data.filter((item, index) => index < data.length - 1);
      } else {
        const newData = [...this.data];
        const target = newData.filter(item => id === item.id)[0];
        if (target ) {
          Object.assign(target, this.cacheData.filter(item => id === item.id)[0]);
          delete target.editable;
          this.data = newData;
        }
      }
      this.editingKey = ''
    },
    handleAdd() {
      const { count, data } = this;
      const newData = {
        key: 'new',
        editable: true,
        standardTimeObj: {
          day: 0,
          hour: 0,
          minute: 0,
          second: 0
        },
        shiftCapacity: 0,
        productTypeId: '',
        standardWeek: 7,
        standardTime: 0,
        colour: '#fff',
        productCode: '',
        productInfo: '',
        productName: '',
        standardMonth: 31
      };
      this.editingKey = count
      this.data = [...data, newData];
      this.count = count + 1;
      // this.changeProductType(this.productTypeList[0].id, {})
    },
    handleDelete(record) {
      deviceStandardSettingServiceProxy.deleteDeviceStandardSetting([record.id]).then(res => {
        this.$message.info(this.$t('delete_success'))
        this.getList()
      })
    },
    changeStandardTime($event, type, record) {
      console.log(111, $event, type, record)
    },
    importSetting() {
      //
    },
    exportSetting () {
      //
    },
    countTime() {
      this.countVisible = true
    },
    countFinish(checkedObj) {
      this.countClose()
      console.log(111, checkedObj,this.editingKey, this.data)
      let record = this.data.find(res => res.id === this.editingKey)
      if (!record) {
          record = this.data[this.data.length - 1]
      }
      // 计算
       const originStandardTime = this.covertStardTimeToSecond(record.standardTimeObj)
      record.standardTime =  originStandardTime
      // 标准用时转成天
      if (checkedObj.day.checked) {
        let standardCapacityDay = this.covertStandardTime(((24 * 60 * 60 -  (24 * 60 * 60 % (record.standardTime)))/ record.standardTime).toString())
        record.standardCapacityDay = standardCapacityDay
      }

      if (checkedObj.week.checked) {
        record.standardCapacityWeek = this.covertStandardTime((((checkedObj.week.num * 24 * 60 * 60) -  (checkedObj.week.num * 24 * 60 * 60) % (record.standardTime)) / record.standardTime).toString())
      }
      // 这边得做个位数的四舍五入
      if (checkedObj.month.checked) {
        record.standardCapacityMonth = this.covertStandardTime((((checkedObj.month.num * 24 * 60 * 60) -  (checkedObj.month.num * 24 * 60 * 60) % (record.standardTime)) / record.standardTime).toString())
      }
      console.log(2222, record)
    },
    countClose() {
      this.countVisible = false
    }
  },
});
</script>
<style lang="less" scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.button-wapper{
  margin-bottom: 8px;
}
.input-number{
  width:50px;
}
.bg-color{
  display: flex;
  width: 300px;
  height: 20px;
}
 /deep/.box {
   position: unset !important;
   visibility: visible !important;
    opacity: 1 !important;
    z-index: 1 !important;
 }


 /deep/ .ant-tree-node-content-wrapper {
    position: relative;
  }

  /deep/ .ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon svg {
    transform: rotate(0deg)!important;
  }

  /deep/ .ant-tree-title {
    position: relative;
  }

  /deep/ .ant-tree-switcher {
    color: rgba(0, 0, 0, 0)!important;
    position: relative;
    z-index: 99;
  }

  /deep/ .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background-color: rgb(255, 241, 184);
  }


</style>
